import React, { useState, useEffect } from "react";
import ReactPlayer from "react-player";
import ShoppingTokenImage from "../../assets/media/pending_token.png";
import PremierTokenImage from "../../assets/media/token_earning/premier_token.png";
import placeHolder from "../../assets/media/token_earning/placeholder.png";
import {
  VIDEO_UPLOAD,
  IMAGE_UPLOAD,
  GIF_UPLOAD,
  YOUTUBE_URL,
} from "../../Constants/types";
import { getYoutubeId } from "../../Utils/utils";
import "./TokenCard.css";
const TokenCard = ({ item, onItemClicked }) => {
  const { media_type, media_url } = item;
  const renderHeroDiv = () => {
    if (!media_url)
      return (
        <div
          className="hero-img"
          style={{
            backgroundImage: `url(${placeHolder})`,
          }}
        >
          <div></div>
          <p>{item ? item.title : ""}</p>
        </div>
      );
    if (media_type === IMAGE_UPLOAD || media_type === GIF_UPLOAD)
      return (
        <div
          className="hero-img"
          style={{
            backgroundImage: media_url
              ? `url(${media_url})`
              : `url(${placeHolder})`,
          }}
        >
          <div></div>
          <p>{item ? item.title : ""}</p>
        </div>
      );
    if (media_type === VIDEO_UPLOAD)
      return (
        <div className="hero-img">
          <ReactPlayer
            url={media_url}
            width="100%"
            height="100%"
            controls={true}
          />
          <p>{item ? item.title : ""}</p>
        </div>
      );
    if (media_type === YOUTUBE_URL)
      return (
        <div className="hero-img">
          <iframe
            title="video"
            width="100%"
            height="100%"
            src={`//www.youtube.com/embed/${getYoutubeId(
              media_url
            )}?modestbranding=1&showinfo=0`}
            frameBorder="0"
            allowFullScreen
          ></iframe>
          <p>{item ? item.title : ""}</p>
        </div>
      );
  };
  return (
    <div
      className="token-item"
      onClick={onItemClicked && onItemClicked}
      data-toggle="modal"
      data-target={`${
        item.pending
          ? "#approve_brand_token_earning_modal"
          : "#edit_token_earning_modal"
      }`}
    >
      {renderHeroDiv()}

      <div className="content-div">
        <div
          className="token_img"
          style={{ backgroundImage: `url("${item ? item.icon : ""}")` }}
        />
        <div className="token-item-number">
          <img
            src={
              item.tokenType === "premier"
                ? PremierTokenImage
                : ShoppingTokenImage
            }
            alt="token"
          ></img>
          <p>{item ? item.token : 100}</p>
        </div>
      </div>
    </div>
  );
};
export default TokenCard;



// WEBPACK FOOTER //
// ./src/screens/TokenEarning/TokenCard.js